import { render, staticRenderFns } from "./UserPostInteractive.vue?vue&type=template&id=60273caf"
import script from "./UserPostInteractive.vue?vue&type=script&lang=js"
export * from "./UserPostInteractive.vue?vue&type=script&lang=js"
import style0 from "./UserPostInteractive.vue?vue&type=style&index=0&id=60273caf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports